export default {
  productLineRow1: '产线引擎使得生产运营和生产活动数字化，以保证生产计划和产品品质的达成。产线引擎承载MPM的数字化工艺，下达生产指令到现场设备，并按照时序配置和驱动设备运行。',
  productLineRow2: '生产计划变化时能够快速调整人、机和料；',
  productLineRow3: '避免因切线、工程变更、测试版本升级或其它变化所导致的品质或设备问题；',
  productLineRow4: '业务需求变化时能够快速做出相应的调整；',
  productLineRow5: '降低昂贵的硬件和集成成本。'
}
